module.exports = __webpack_public_path__ + "static/media/hand_open.088ae580.jpg";